import { render, staticRenderFns } from "./TermsPoliticsModal.vue?vue&type=template&id=4bb57192&scoped=true&"
import script from "./TermsPoliticsModal.vue?vue&type=script&lang=js&"
export * from "./TermsPoliticsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsPoliticsModal.vue?vue&type=style&index=0&id=4bb57192&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb57192",
  null
  
)

export default component.exports